import { render } from "./SiteFooter.vue?vue&type=template&id=07a37ed6&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=07a37ed6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a37ed6"]])

export default __exports__